import { declareParams } from '@farfetched/core';
import { zodContract } from '@farfetched/zod';
import { createAuthMutation } from '../auth-http-client';
import { uuidResponseSchema } from '../types';

export type WithdrawWalletMutationParams = {
	accountId: number;
	currency: string;
	amount: number;
};

export const createWithdrawWalletMutation = () =>
	createAuthMutation({
		params: declareParams<WithdrawWalletMutationParams>(),
		request: {
			method: 'POST',
			url: '/account/withdraw',
			body: (data) => data,
		},
		response: {
			contract: zodContract(uuidResponseSchema),
		},
	});
